import { create } from "zustand";

const DEFAULT_DATA = {
  drawers: {
    main: false,
    templates: true,
    settings: true,
  },
  macro: undefined,
  hasStyleguidePermission: false,
  advancedMacroEmptyState: false,
};

export const useOpticsStore = create((set, get) => ({
  drawers: DEFAULT_DATA.drawers,
  macro: DEFAULT_DATA.macro,
  hasStyleguidePermission: DEFAULT_DATA.hasStyleguidePermission,
  advancedMacroEmptyState: DEFAULT_DATA.advancedMacroEmptyState,
  isEditingOldMacro: false,

  isCosmosInstalled: false,
  setIsCosmosInstalled: (value) => set(() => ({ isCosmosInstalled: value })),

  unsplashSearch: "",
  setUnsplashSearch: (value) => set(() => ({ unsplashSearch: value })),

  colorPalette: undefined,
  setColorPalette: (value) => set(() => ({ colorPalette: value })),

  styleguideSetup: {},
  setStyleguideSetup: (value) => set(() => ({ styleguideSetup: value })),

  isDrawerModalOpen: false,
  setIsDrawerModalOpen: (value) => set(() => ({ isDrawerModalOpen: value })),

  isWarningModalOpen: false,
  setIsWarningModalOpen: (value) => set(() => ({ isWarningModalOpen: value })),

  selectedTemplateTab: {
    button: "fl",
    cards: "fl",
    panel: "fl",
  },
  setSelectedTemplateTab: ({ macro, tab }) => {
    const currentValue = get().selectedTemplateTab;
    set(() => ({
      selectedTemplateTab: { ...currentValue, [macro]: tab },
    }));
  },
  setDrawers: (value) => {
    const currentDrawers = get().drawers;
    set(() => ({
      drawers: { ...currentDrawers, ...value },
    }));
  },
  setMacro: ({ key }) => set(() => ({ macro: key })),
  setHasStyleguidePermission: (value) =>
    set(() => ({ hasStyleguidePermission: value })),
  setAdvancedMacroEmptyState: (value) =>
    set(() => ({ advancedMacroEmptyState: value })),
  setIsEditingOldMacro: (value) => set(() => ({ isEditingOldMacro: value })),

  libraryButtons: [],
  libraryPanels: [],
  libraryCards: [],

  setLibraryButtons: (value) => set(() => ({ libraryButtons: value })),
  setLibraryPanels: (value) => set(() => ({ libraryPanels: value })),
  setLibraryCards: (value) => set(() => ({ libraryCards: value })),
}));

export const useEmptyStore = create((set) => ({}));
